export enum SipCase {
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
  START = 'START',
  STOP_UNDER_PERFORMING_FUND_WITH_EXPOSURE = 'STOP_UNDER_PERFORMING_FUND_WITH_EXPOSURE',
  STOP_UNDER_PERFORMING_FUND_WITHOUT_EXPOSURE = 'STOP_UNDER_PERFORMING_FUND_WITHOUT_EXPOSURE',
  STOP_WELL_PERFORMING_FUND_WITHOUT_EXPOSURE = 'STOP_WELL_PERFORMING_FUND_WITHOUT_EXPOSURE',
  STOP_IN_FORM_FUND_WITH_EXPOSURE = 'STOP_IN_FORM_FUND_WITH_EXPOSURE',
  STOP_ON_TRACK_FUND_WITH_EXPOSURE = 'STOP_ON_TRACK_FUND_WITH_EXPOSURE'
}

export interface SipPlanIdealAllocationPercentage {
  upperLimit?: number | null
  lowerLimit?: number | null
  absolute?: number | null
}

export interface SipPlanScoringData {
  recencyScore?: number | null
  consistencyScore?: number | null
  volatilityScore?: number | null
  maxScore?: number | null
  consistencyScorePerformanceTag?: string | null
  recencyScorePerformanceTag?: string | null
  volatilityScorePerformanceTag?: string | null
}

/** SIP bottom-sheet API response — shape varies by sipRecommendationCase. */
export interface SipPlanRecommendationApiResponse {
  sipRecommendationCase?: SipCase | null
  isin?: string | null
  fundName?: string | null
  fundNature?: string | null
  fundCategory?: string | null
  derivedCategory?: string | null
  categoryName?: string | null
  purchaseMode?: string | null
  distributionStatus?: string | null
  mfLogoUrl?: string | null
  powerRating?: string | null
  powerRank?: number | null
  totalCategoryCount?: number | null
  currentSip?: number | null
  idealSip?: number | null
  idealAllocationPercentage?: SipPlanIdealAllocationPercentage | null
  scoringData?: SipPlanScoringData | null
  planSnapshotDate?: number | null
}

export type SipPlanRecommendationDetails = SipPlanRecommendationApiResponse
